import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubscription } from 'store/auth/subscription/subscriptionSlice';
import FilePreview from './FilePreview';

const SubscriptionDetails = () => {
    const dispatch = useDispatch();
    const subscription = useSelector((state) => state.Subscription);

    const [isUrgent, setIsUrgent] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        dispatch(getSubscription());
    }, [dispatch]);

    useEffect(() => {
        const endDateStr = subscription?.subscription?.subscriptionEndDate;
        if (!endDateStr) {
            setIsUrgent(false);
            setMessage("");
            return;
        }

        const today = new Date();
        const endDate = new Date(endDateStr);
        const diff = endDate - today;
        const oneWeek = 7 * 24 * 60 * 60 * 1000;

        if (diff > 0 && diff <= oneWeek) {
            setIsUrgent(true);
            setMessage("Votre abonnement arrive bientôt à expiration. Pensez à le renouveler !");
        } else {
            setIsUrgent(false);
            setMessage("");
        }
    }, [subscription?.subscription?.subscriptionEndDate]);

    const containerStyle = {
        width: '100%',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginTop: '16px',
        backgroundColor: isUrgent ? '#ffe5e5' : '#f6f6f6',
        animation: isUrgent ? 'scalePulse 1s infinite alternate' : 'none',
        transformOrigin: 'center center',
    };
    const headerStyle = { textAlign: 'center', marginBottom: '24px' };
    const titleStyle = { fontSize: '20px', fontWeight: 'bold', color: '#1e3a8a' };
    const subtitleStyle = { fontSize: '14px', color: '#3b82f6' };
    // const imageStyle = { height: '160px', borderRadius: '8px', border: '2px solid #bfdbfe', objectFit: 'cover' };
    const logoStyle = { height: '40px', marginBottom: '8px' };
    const dateLabelStyle = { fontSize: '10px', color: '#3b82f6', textTransform: 'uppercase' };
    const dateTextStyle = { marginTop: '20px', fontSize: '14px', fontWeight: 'bold', color: '#1e40af' };
    const messageStyle = { textAlign: 'center', fontSize: '13px', color: isUrgent ? '#b91c1c' : '#047857', marginTop: '16px' };

    return (
        <div>
            <style>
                {`
          @keyframes scalePulse {
            0% { transform: scale(1); }
            100% { transform: scale(1.02); }
          }
        `}
            </style>

            <div style={containerStyle}>
                <div style={headerStyle}>
                    <img src="/logo.png" alt="Playmaker Logo" style={logoStyle} />
                    <h2 style={titleStyle}>Abonnement Playmaker</h2>
                    <p style={subtitleStyle}>1 an pour 3 000 DA</p>
                </div>


                {subscription?.subscription?.paymentImage && (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: '24px',
                        }}
                    >
                        <FilePreview paymentImage={subscription?.subscription?.paymentImage} />
                    </div>
                )}


                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '40px' }}>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <p style={dateLabelStyle}>Début</p>
                        <p style={{ ...dateTextStyle, color: '#2563eb' }}>
                            {subscription?.subscription?.subscriptionStartDate
                                ? new Date(subscription?.subscription?.subscriptionStartDate)?.toLocaleDateString()
                                : '—'}
                        </p>
                    </div>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <p style={dateLabelStyle}>Fin</p>
                        <p style={{ ...dateTextStyle, color: isUrgent ? '#dc2626' : '#1e40af' }}>
                            {subscription?.subscription?.subscriptionEndDate
                                ? new Date(subscription?.subscription?.subscriptionEndDate)?.toLocaleDateString()
                                : '—'}
                        </p>
                    </div>
                </div>

                {message && <div style={messageStyle}>{message}</div>}
            </div>
        </div>
    );
};

export default SubscriptionDetails;
